import type { FunctionComponent } from 'react';

import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { footerQualityPaymentTitle } from '@/domains/retention/Footer/translations';

import { PaymentMeans } from './PaymentMeans.default';

export const Payment: FunctionComponent = () => (
  <>
    <Typography className="flex items-center" scale="body1" weight="bold">
      {footerQualityPaymentTitle}
    </Typography>
    <PaymentMeans />
  </>
);

Payment.displayName = 'Payment';
